import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import { isFunction } from 'lodash';
import {
  FETCH_FILTER_ORDER_HISTORY,
  FETCH_PAIRS_ORDER_HISTORY, FETCH_USER_OPEN_ORDER_HISTORY,
  FETCH_USER_ORDER_HISTORY, SEARCH_ORDER_BY_ID,
} from '../actions/order_history/action_types';
import actions from '../actions/order_history/index';
import rf from '../../requests/RequestFactory';
import utils from '../../common/utils';
// saga effect

function* fetchFilterOrderHistory(action) {
  try {
    const { data, total_count } = yield call((params) => rf.getRequest('OrderHistoryRequest').fetchFilterOrderHistory(params), action.params);
    if (isFunction(action.callback)) {
      yield action.callback(total_count);
    }
    yield put(actions.fetchFilterOrderHistoryActionSucceed(data, total_count));
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchFilterOrderHistoryActionFailed(err));
  }
}

function* fetchOrderHistory(action) {
  try {
    const { data, total_count } = yield call((params) => rf.getRequest('OrderHistoryRequest').fetchOrderHistory(params), action.params);
    if (isFunction(action.callback)) {
      yield action.callback(total_count);
    }
    yield put(actions.fetchUserOrderHistorySucceed(data, total_count));
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchUserOrderHistoryFailed(err));
  }
}

function* fetchOpenOrder(action) {
  try {
    const { data, total_count } = yield call((params) => rf.getRequest('OrderHistoryRequest').fetchUserOpenOrder(params), action.params);
    if (isFunction(action.callback)) {
      yield action.callback(total_count);
    }
    yield put(actions.fetchUserOpenOrderHistorySucceed(data, total_count));
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchUserOpenOrderHistoryFailed(err));
  }
}

function* searchOrderById(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('OrderHistoryRequest').searchOrderById(params), action.params);
    if (isFunction(action.callback)) {
      yield action.callback(data);
    }
    // yield put(actions.searchOrderByIDActionSucceed(data));
  } catch (err) {
    yield put(actions.searchOrderByIDActionFailed(err));
  }
}

function* watchOrderHistory() {
  yield takeLatest(FETCH_FILTER_ORDER_HISTORY, fetchFilterOrderHistory);
  yield takeLatest(FETCH_USER_ORDER_HISTORY, fetchOrderHistory);
  yield takeLatest(FETCH_USER_OPEN_ORDER_HISTORY, fetchOpenOrder);
  yield takeLatest(SEARCH_ORDER_BY_ID, searchOrderById);
}

export default function* rootSaga() {
  yield all([fork(watchOrderHistory)]);
}
